import dynamic from 'next/dynamic'
import customTypes, { getCustomOptionTypeComponent } from './custom-types'

const Field = dynamic(() => import('./type/field'))
const Area = dynamic(() => import('./type/area'))
const DropDown = dynamic(() => import('./type/dropdown'))
const Radio = dynamic(() => import('./type/radio'))
const Checkbox = dynamic(() => import('./type/checkbox'))
const Multiple = dynamic(() => import('./type/multiple'))
const Default = dynamic(() => import('./type/default'))
const Date = dynamic(() => import('./type/date'))
const Time = dynamic(() => import('./type/time'))
const DateTime = dynamic(() => import('./type/date-time'))
const File = dynamic(() => import('./type/file'))

const types = {
	field: Field,
	area: Area,
	drop_down: DropDown,
	radio: Radio,
	checkbox: Checkbox,
	multiple: Multiple,
	date: Date,
	time: Time,
	date_time: DateTime,
	file: File,
	default: Default,
	...customTypes,
}

export const getCustomOptionComponent = (customOption) => {
	const { type } = customOption
	return getCustomOptionTypeComponent(customOption) ?? types[type] ?? types.default
}
